import { NavLink, Outlet, useParams } from "react-router-dom";
import { Logo } from "../components/Logo";

export default function MagicApp() {
  const { token } = useParams<{ token: string }>();
  const navCls = ({ isActive }: { isActive: boolean }) =>
    isActive ? "pp-nav-pill-active" : "pp-nav-pill";

  if (!token) return null;
  const base = `/backoffice/m/${token}`;

  return (
    <main className="pp-shell p-4 pb-24 max-w-5xl mx-auto">
      <header className="pp-card mb-6 flex flex-wrap items-center justify-between gap-4 p-4 shadow-ppCard">
        <div className="flex min-w-0 flex-wrap items-center gap-3">
          <Logo variant="icon" iconSize={40} aria-label="Encuesta" />
          <div className="min-w-0">
            <Logo variant="mark" className="-ml-1" />
            <p className="mt-1 text-xs text-pp-muted">Backoffice temporal</p>
          </div>
        </div>
      </header>
      <nav className="mb-6 flex flex-wrap gap-2 pp-nav-pills p-1" aria-label="Secciones backoffice">
        <NavLink to={base} end className={navCls}>
          Embudo
        </NavLink>
        <NavLink to={`${base}/validation-score`} className={navCls}>
          Validation Score
        </NavLink>
        <NavLink to={`${base}/responses`} className={navCls}>
          Respuestas
        </NavLink>
      </nav>
      <Outlet />
    </main>
  );
}
